import config from '../config';
import { getGameEntity } from './entity';

export interface leaderboardConfigEntity {
    leaderboardName: string;
    displayName: string;
}

export interface leaderboardConfig {
    global: leaderboardConfigEntity[];
    user: leaderboardConfigEntity[];
}

export interface leaderboardData {
    name: string;
    order: string;
    timeframes: leaderboardTimeframe[];
    scoreconfig: any[];
}

export interface leaderboardTimeframe {
    all: boolean;
    daily: any[];
    monthly: any[];
    weekly: any[];
    yearly: any[];
}

export interface rankingData {
    id: string;
    rank: number;
    score: number;
    data: string;
}

export const getLeaderboardConfig = async (
    gameID: string,
    token?: string,
): Promise<leaderboardConfig> => {
    if (gameID === '') {
        return {
            global: [],
            user: [],
        };
    }

    const entityData = await getGameEntity(gameID, 'wrapper-leaderboards', token);
    return entityData.data;
};

export const getLeaderboards = async (licenseID: string): Promise<leaderboardData[]> => {
    const resp = await fetch(`${config.leaderboardServiceURL}/game/${licenseID}/leaderboard`, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
    });

    if (resp.status !== 200) {
        console.error(await resp.text());
        return [];
    }

    const data = await resp.json();

    const leaderboardsMap = data.data.leaderboards;

    return Object.keys(leaderboardsMap).map((name) => leaderboardsMap[name]);
};

export const getLeaderboardRanking = async (
    licenseID: string,
    leaderboardName: string,
    timeframe: string,
    userId: string,
): Promise<rankingData[]> => {
    let url = `${config.leaderboardServiceURL}/game/${licenseID}/leaderboard/${leaderboardName}/ranking/${timeframe}`;
    if (userId !== '') {
        url += `?user=${userId}`;
    }
    const resp = await fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
    });

    if (resp.status !== 200) {
        console.error(await resp.text());
        return [];
    }

    const data = await resp.json();

    const rankingMap = data.data.ranking;

    return Object.keys(rankingMap).map((rank) => rankingMap[rank]);
};

export const getAggregatedScores = async (
    licenseID: string,
    aggregated: boolean,
    timeframe: string,
    season: string,
    userId: string,
): Promise<rankingData[]> => {
    let url = '';
    if (aggregated) {
        url = `${config.leaderboardServiceURL}/game/${licenseID}/points/ranking/aggregated/${timeframe}`;
    } else {
        url = `${config.leaderboardServiceURL}/game/${licenseID}/points/ranking/${timeframe}`;
    }

    if (season !== '') {
        url += `?season=${season}`;
        if (userId !== '') {
            url += `&user=${userId}`;
        }
    } else if (userId !== '') {
        url += `?user=${userId}`;
    }

    const resp = await fetch(url, {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'GET',
    });

    if (resp.status !== 200) {
        console.error(await resp.text());
        return [];
    }

    const data = await resp.json();

    const rankingMap = data.data.ranking;

    return Object.keys(rankingMap).map((rank) => rankingMap[rank]);
};
